import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    {
      icon: 'fab fa-linkedin-in',
      url: 'https://www.linkedin.com/in/chanuthsilva',
      name: 'LinkedIn'
    },
    {
      icon: 'fab fa-github',
      url: 'https://github.com/Chanuth-silva10',
      name: 'GitHub'
    },
    {
      icon: 'fab fa-stack-overflow',
      url: 'https://stackoverflow.com/users/17134706/kumara-maduka',
      name: 'Stack Overflow'
    },
    {
      icon: 'fas fa-blog',
      url: 'https://chanuth-silva-project-blog.onrender.com',
      name: 'Blog'
    }
  ];

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' }
  ];

  const skills = [
    'Full Stack Development',
    'Java & Spring Boot',
    'React & Angular',
    'AWS & DevOps',
    'Microservices',
    'Database Design'
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h3>Chanuth Silva</h3>
            <p>
              Full Stack Software Engineer passionate about creating scalable, 
              innovative solutions using modern technologies. Always ready for 
              new challenges and opportunities to grow.
            </p>
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  title={link.name}
                >
                  <i className={link.icon}></i>
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="footer-section links-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>{link.name}</a>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <div className="footer-section skills-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4>Core Skills</h4>
            <div className="skills-grid">
              {skills.map((skill, index) => (
                <span key={index} className="skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="footer-section contact-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4>Get In Touch</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:chanuth.silva2025@gmail.com">
                  chanuth.silva2025@gmail.com
                </a>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <span>+94 (0) 774185595</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>Ambalangoda, Sri Lanka</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            © {currentYear} Chanuth Silva. All rights reserved. Built with React & passion for technology.
          </motion.p>
          <motion.div
            className="footer-tech-stack"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <span>Built with:</span>
            <div className="tech-icons">
              <i className="fab fa-react" title="React"></i>
              <i className="fab fa-js-square" title="JavaScript"></i>
              <i className="fab fa-css3-alt" title="CSS3"></i>
              <i className="fab fa-html5" title="HTML5"></i>
            </div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
